import { orderTypeIds } from "./orderTypeIds";
import { isControlPurchasePurpose } from "../functions/factorObjectVisibility";

/** Статус соответствия протокола (complianceStatus). */
export const COMPLIANCE_STATUS = {
  COMPLIES: 0,
  DOES_NOT_COMPLY: 1,
};

export const COMPLIANCE_STATUS_OPTIONS = [
  { id: COMPLIANCE_STATUS.COMPLIES, name: "Соответствует" },
  { id: COMPLIANCE_STATUS.DOES_NOT_COMPLY, name: "Не соответствует" },
];

/** Статус подтверждения протокола (confirmationStatus). */
export const CONFIRMATION_STATUS = {
  PENDING: 0,
  CONFIRMED: 1,
  REJECTED: 2,
};

export const CONFIRMATION_STATUS_LABELS = {
  [CONFIRMATION_STATUS.PENDING]: "Ожидает решения",
  [CONFIRMATION_STATUS.CONFIRMED]: "Подтверждён",
  [CONFIRMATION_STATUS.REJECTED]: "Отклонён",
};

export function getComplianceStatusLabel(status) {
  const n = Number(status);
  if (n !== 0 && n !== 1) return "";
  const opt = COMPLIANCE_STATUS_OPTIONS.find((o) => o.id === n);
  return opt?.name || "";
}

export function getConfirmationStatusLabel(status) {
  if (status == null || status === "") return "";
  const n = Number(status);
  return CONFIRMATION_STATUS_LABELS[n] || "";
}

/** Нормализация complianceStatus из API (number | string | PascalCase). */
export function normalizeComplianceStatus(value) {
  if (value === 0 || value === "0") return COMPLIANCE_STATUS.COMPLIES;
  if (value === 1 || value === "1") return COMPLIANCE_STATUS.DOES_NOT_COMPLY;
  const n = Number(value);
  if (n === COMPLIANCE_STATUS.COMPLIES || n === COMPLIANCE_STATUS.DOES_NOT_COMPLY) {
    return n;
  }
  return null;
}

/** Нормализация confirmationStatus из API. */
export function normalizeConfirmationStatus(value) {
  if (value == null || value === "") return null;
  const n = Number(value);
  if (
    n === CONFIRMATION_STATUS.PENDING ||
    n === CONFIRMATION_STATUS.CONFIRMED ||
    n === CONFIRMATION_STATUS.REJECTED
  ) {
    return n;
  }
  return null;
}

/**
 * Показывать «Статус соответствия» только для госзаказа
 * с целью отбора «Контрольный закуп (мониторинг безопасности)».
 */
export function shouldShowProtocolCompliance({ orderType, purpose } = {}) {
  return (
    Number(orderType) === orderTypeIds.government &&
    isControlPurchasePurpose(purpose)
  );
}
